import { render, staticRenderFns } from "./OrganizationSummary.vue?vue&type=template&id=784d4a48&"
import script from "./OrganizationSummary.vue?vue&type=script&lang=js&"
export * from "./OrganizationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports